import { render, staticRenderFns } from "./FrecuenciasIndex.vue?vue&type=template&id=3916e53e"
import script from "./FrecuenciasIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./FrecuenciasIndex.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports